import WalletCard from '../../../../../components/WalletCard/WalletCard';
import InvestifyWTAC from '../../../../../assets/icons/InvestifyWTAC.svg';
import { IpoIdentifierCardsProps } from '../../../../../types';

const IpoIdentifierCards = ({ chn, cscs }: IpoIdentifierCardsProps) => (
  <div className="cards-container flex--2 ipo-identifier-cards">
    <WalletCard
      title="CHN"
      cardId="ipo-chn"
      image={InvestifyWTAC}
      imgSizeInPercent={40}
      balance={0}
      showBalance
      isBalance={false}
      isText
      text={chn || '—'}
      walletKey="investify"
      cardClick={() => {}}
    />
    <WalletCard
      title="CSCS"
      cardId="ipo-cscs"
      image={InvestifyWTAC}
      imgSizeInPercent={40}
      balance={0}
      showBalance
      isBalance={false}
      isText
      text={cscs || '—'}
      walletKey="investify"
      cardClick={() => {}}
    />
  </div>
);

export default IpoIdentifierCards;
